exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[type=\"range\"][data-v-51ab0cca] {\n    width: 200px;\n}\n", ""]);

// exports
